import { useState, useEffect } from 'react';
import { getActiveLivestreams } from '../api/stream';

export function useActiveStreams() {
  const [activeStreams, setActiveStreams] = useState<Set<string>>(new Set());

  useEffect(() => {
    let active = true;
    
    const fetchStreams = async () => {
      try {
        const streams = await getActiveLivestreams();
        if (!active) return;
        const streamIds = new Set(streams.map(s => s.match_id));
        setActiveStreams(streamIds);
      } catch (err) {
        console.error('Error fetching active streams:', err);
      }
    };

    fetchStreams();
    const interval = setInterval(fetchStreams, 60000); // refresh every minute

    return () => {
      active = false;
      clearInterval(interval);
    };
  }, []);

  return activeStreams;
}
